export enum Country {
  AUSTRALIA = 'Australia',
  NEW_ZEALAND = 'New Zealand',
}
